// ** React Imports
import React from 'react';
// ** Third Party Imports
import { Image } from 'react-bootstrap';
// ** Asset Imports
import GeneratedByAiIcon from '../../../../../../../assets/images/generated-by-ai-icon.svg';
// ** Constant Imports
import { AiVariantSkeletons } from './constants';
// ** Component Imports
import TextEditorSkeleton from './text-editor-skeleton';

/**
 * @description This component return loading screen for text editor when AI is generating content
 * @returns React Component
 */
const TextEditorSkeletonContainer: React.FC = () => (
  <div className="text-editor-skeleton-overlay-container">
    <div className="tooltip-spacer" />
    <div className="ai-variant-skeleton-content">
      <div className="loading-icon-text-container">
        <Image
          className="loading-icon-text-container__icon"
          src={GeneratedByAiIcon}
          alt="ai-icon"
        />

        <span className="loading-icon-text-container__text">
          Hang tight, it’s loading...
        </span>
      </div>
      <div className="skeletons-container">
        <div className="skeletons-container__paragraph">
          <TextEditorSkeleton
            textEditorSkeletonsList={AiVariantSkeletons.emailHeading}
          />
          <TextEditorSkeleton
            textEditorSkeletonsList={AiVariantSkeletons.firstParagraph}
          />
        </div>
        <div className="skeletons-container__paragraph">
          <TextEditorSkeleton
            textEditorSkeletonsList={AiVariantSkeletons.secondParagraph}
          />
        </div>
        <div className="skeletons-container__paragraph">
          <TextEditorSkeleton
            textEditorSkeletonsList={AiVariantSkeletons.thirdParagraph}
          />
        </div>
      </div>
    </div>
  </div>
);

export default TextEditorSkeletonContainer;
